// Receiver identifiers supported by the manual Venezuela payment forms.
// bank_name is a display label, e.g. "BNC - 0191", not an API identifier.
const RECEIVERS = ['bnc', 'mercantil', 'r4'];

type PaymentDetail = {
	bank_name?: string; api_type?: string; is_active?: boolean; order?: number;
	phone_number?: string; rif?: string; account_number?: string; account_type?: string;
};
type PaymentMethod = { is_active?: boolean; payment_details?: PaymentDetail[] };
type PaymentSettings = { payment_methods?: Record<string, PaymentMethod> };

export function receivingBankApiType(detail: PaymentDetail): string | undefined {
	const configured = typeof detail.api_type === 'string' ? detail.api_type.trim().toLowerCase() : '';
	return RECEIVERS.includes(configured) ? configured : undefined;
}

export function activePaymentDetails(settings: PaymentSettings | null, paymentType: string): PaymentDetail[] {
	const method = settings?.payment_methods?.[paymentType];
	if (!method || method.is_active === false || !Array.isArray(method.payment_details)) return [];
	return method.payment_details
		.filter((detail) => detail && detail.is_active !== false)
		.filter((detail) => paymentType === 'transfer_usd' || (
			!!receivingBankApiType(detail) && !(receivingBankApiType(detail) === 'r4' && paymentType !== 'p2c')
		))
		.slice()
		.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function paymentAccountDetails(settings: PaymentSettings | null, paymentType: string) {
	return activePaymentDetails(settings, paymentType)
		.filter((detail) => paymentType === 'p2c' ? detail.phone_number : detail.account_number)
		.map((detail) => ({
			api_type: receivingBankApiType(detail),
			bank: detail.bank_name, rif: detail.rif, phoneNumber: detail.phone_number,
			account: detail.account_number, type: detail.account_type
		}));
}

export function receivingBankOptions(settings: PaymentSettings | null, paymentType: string) {
	const seen = new Set<string>();
	return activePaymentDetails(settings, paymentType)
		.flatMap((detail) => {
			const value = receivingBankApiType(detail);
			if (!value || seen.has(value) || (value === 'r4' && paymentType !== 'p2c')) return [];
			seen.add(value);
			return [{ label: detail.bank_name || value.toUpperCase(), value }];
		});
}

export function manualReceiverPayload(receiver: string) {
	return receiver === 'auto' ? {} : { api_type: receiver };
}
